// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const JINYANG_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  prescriptionAmount: ['EDI'],
  settlementAmount: ['정산금액'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '실적월',
  '처방처명',
  '사업자번호',
  'EDI',
  '소급금액',
  '정산금액',
  '흡수율',
  '주의사항',
  '차감예정금액',
  '차감예정월',
  '비고',
];

function isJinyangProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const jinyangPharmTemplate = {
  id: 'jinyang-pharm',
  name: '진양제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isJinyangProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isJinyangProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(JINYANG_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '진양제약';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const hospitalName = cleanText(row[columnMap.hospitalName]);
      if (!hospitalName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: hospitalName,
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default jinyangPharmTemplate;
